// Client-модели REST-контракта warehouse (зеркалят бэковые client-DTO из
// services/orders/warehouse/v1/models/client). БД-модели фронт не видит.

// Значения совпадают с OrderStatusIds на бэке. Preorder и Paid в интерфейсе не выбираются,
// но приходят у старых заказов, поэтому в типе они есть.
export enum OrderStatusDto {
    preorder = "Preorder",
    new = "New",
    accepted = "Accepted",
    canceled = "Canceled",
    canceledWithRefund = "CanceledWithRefund",
    sentToKitchen = "SentToKitchen",
    canceledByKitchen = "CanceledByKitchen",
    acceptedByKitchen = "AcceptedByKitchen",
    ready = "Ready",
    givenOut = "GivenOut",
    givenOutToDelivery = "GivenOutToDelivery",
    readyToPickUp = "ReadyToPickUp",
    finished = "Finished",
    paid = "Paid",
}

export enum OrderDeliveryTypeDto {
    toTable = "ToRestaurantTable",
    insideTheRestaurant = "InsideTheRestaurant",
    toAddress = "ToAddress",
    takeAway = "TakeAway",
    takeAwayToTime = "TakeAwayToTime",
    toVehicle = "ToVehicle",
}

export enum OrderPaymentTypeDto {
    cloudPayments = "CloudPaymentsCheckout",
    sbpTochka = "SBPTochka",
    offline = "Offline",
    bankCard = "BankCardRequisites",
    companyInvoice = "CompanyBankAccountRequisites",
}

export interface PriceDto {
    currencyId: string;
    // Минорные единицы (копейки).
    price: number;
}

export interface LocalizedTextDto {
    [locale: string]: string;
}

/*
* Плоские детали оплаты: подтипов на бэке семь, но кабинету от них нужен один набор полей.
* canRefund считает бэк — кабинет больше не выводит возможность возврата сам.
* */
export interface OrderPaymentDetailsDto {
    type: OrderPaymentTypeDto;
    /*
    * Оплата шла через нас (эквайринг или СБП). У остальных способов признак isPaid смысла не
    * имеет — деньги берёт курьер или официант, — поэтому по таким заказам не показываем ни
    * «оплачен», ни «не оплачен». Какие провайдеры считаются онлайновыми, решает бэк.
    * */
    isOnline: boolean;
    isPaid: boolean;
    receiptLink: string | null;
    refundReceiptLink: string | null;
    canRefund: boolean;
}

/*
* Детали доставки — размеченное объединение по type (зеркалит sealed-иерархию бэка).
* Сужение по литеральному type работает и при выключенном strictNullChecks, поэтому именно
* оно здесь ловит обращение к чужому полю.
* */
export interface TableOrderDeliveryDetailsDto {
    type: OrderDeliveryTypeDto.toTable;
    tableId: number;
    seatId: string | null;
    tableTitle: LocalizedTextDto | null;
}

export interface InsideOrderDeliveryDetailsDto {
    type: OrderDeliveryTypeDto.insideTheRestaurant;
}

export interface AddressOrderDeliveryDetailsDto {
    type: OrderDeliveryTypeDto.toAddress;
    address: string;
    phoneNumber: string;
    name: string | null;
    building: string | null;
    porch: string | null;
    floor: number | null;
    flat: number | null;
    comment: string | null;
}

export interface TakeAwayOrderDeliveryDetailsDto {
    type: OrderDeliveryTypeDto.takeAway;
    phoneNumber: string;
    name: string | null;
}

export interface TakeAwayToTimeOrderDeliveryDetailsDto {
    type: OrderDeliveryTypeDto.takeAwayToTime;
    phoneNumber: string;
    name: string | null;
    date: number | null;
    toHour: number | null;
    toMinute: number | null;
}

export interface VehicleOrderDeliveryDetailsDto {
    type: OrderDeliveryTypeDto.toVehicle;
    vehicleBrandName: string;
    vehicleColor: string;
    vehiclePlateNumber: string;
    phoneNumber: string;
}

export type OrderDeliveryDetailsDto =
    | TableOrderDeliveryDetailsDto
    | InsideOrderDeliveryDetailsDto
    | AddressOrderDeliveryDetailsDto
    | TakeAwayOrderDeliveryDetailsDto
    | TakeAwayToTimeOrderDeliveryDetailsDto
    | VehicleOrderDeliveryDetailsDto;

export interface OrderItemModifierDto {
    name: LocalizedTextDto;
    count: number;
    price: PriceDto;
}

export interface OrderItemDto {
    menuItemId: number;
    name: LocalizedTextDto;
    count: number;
    price: PriceDto;
    priceAfterDiscount: PriceDto;
    comment: string | null;
    // Модификаторы разворачивает бэк — искать их по id в снимке набора кабинету не нужно.
    modifiers: OrderItemModifierDto[];
}

export interface OrderStatusChangeDto {
    status: OrderStatusDto;
    // Даты — epoch millis, как их отдаёт бэк (без таймзонной двусмысленности).
    changedAt: number;
}

export interface OrderListDto {
    id: number;
    createdAt: number;
    totalPrice: PriceDto;
    deliveryType: OrderDeliveryTypeDto;
    status: OrderStatusDto;
    paymentDetails: OrderPaymentDetailsDto;
    itemsCount: number;
}

export interface OrdersPageDto {
    items: OrderListDto[];
    total: number;
}

export interface OrderDto {
    id: number;
    menuId: number;
    createdAt: number;
    status: OrderStatusDto;
    comment: string;
    totalPrice: PriceDto;
    paymentDetails: OrderPaymentDetailsDto;
    deliveryDetails: OrderDeliveryDetailsDto;
    items: OrderItemDto[];
    statusHistory: OrderStatusChangeDto[];
}
